<template>
    <section class="registration flow__panel">
        <h2 class="registration__title">
            Register
        </h2>
        <p>
            Fill out the details below to create an account that you can use to keep track of changes to your property.
        </p>
        <p v-if="!redirect"
           class="registration__log-in">
            <router-link class="registration__log-in__link"
                         :to="{ name: 'LogIn' }">
                I already have an account
            </router-link>
        </p>
        <hh-error-display v-if="error"
                          class="registration__error"
                          :error="error" />
        <registration-form class="registration__form"
                           :error="error"
                           @canceled="onCancelled"
                           @error-state-changed="onErrorStateChange"
                           @registered="onRegistered" />
    </section>
</template>

<script>

import Vuex from 'vuex'

import AnalyticsPage from './analytics-page'

import RegistrationForm from '../components/registration/registration-form'

export default {

    props: {
        redirect: {
            type: Object,
            default: null,
        },
    },

    mixins: [
        AnalyticsPage,
    ],

    data() {
        return {
            error: null,
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'lastBackIncludedRoute',
            'lastGuestAccessibleBackIncludedRoute',
        ]),
    },

    /**
   * View mounted event.
   */
    mounted() {
        this.$logger.logObject(this.redirect, 'Registration requested', 'Registration')
    },

    methods: {

        onCancelled() {
            this.$router.push(this.lastGuestAccessibleBackIncludedRoute)
        },

        onErrorStateChange(errState) {
            this.error = errState.error ? errState.msg : null
        },

        onRegistered() {
            if (this.redirect) {
                this.$router.replace(this.redirect.fullPath)
                // In case replace isn't working (it sometimes goes awry)...
                this.$router.push(this.redirect.fullPath)
            } else {
                // If we've not been given a redirect, then go to the dashboard after registration. Backtracking
                // (previously) caused an empty Address page to display after successful registration.
                this.$router.push({ name: 'Dashboard' })
            }
        },
    },

    components: {
        RegistrationForm,
    },
}

</script>

<style lang="scss">

.registration {

    @include bp-min-mid {
        max-width: 80%;
    }

    @include bp-min-wide {
        max-width: 60%;
    }

    @include element('log-in') {

        @include element('link') {
            position: relative;
            top: rem(-12px);
            right: rem(2px);
            float: right;
            font-weight: bold;
        }
    }

    @include element('error') {

        @include modifier('bottom') {
            margin-top: 10px;
        }
    }
}

</style>
